export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-ExtraBoldItalic-3668d18d6426406232cf9061f84a8216.ttf";